export default "__VITE_ASSET__fe781052__"